import { React, useEffect } from 'react';
import Footer from '../components/Footer';

import gal1 from '../images/gal1.jpg';
import gal2 from '../images/gal2.jpg';
import gal3 from '../images/gal3.jpg';
import gal4 from '../images/gal4.jpg';
import gal5 from '../images/gal5.jpg';
import gal6 from '../images/gal6.jpg';

import m1 from '../images/m1.jpg';
import m2 from '../images/m2.jpg';
import m3 from '../images/m3.jpg';
import m4 from '../images/m4.jpg';



import gal7 from '../images/newimg1.jpg';
import gal8 from '../images/newimg2.jpg';
import gal9 from '../images/newimg3.jpg';
import gal10 from '../images/newimg4.jpg';
import gal11 from '../images/newimg5.jpg';
import gal12 from '../images/megh1.jpg';
import gal13 from '../images/megha2.jpg';
import gal14 from '../images/megha3.jpg';
import gal15 from '../images/megh4.jpg';




const Gallery = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className='headings'>
                <h3>Gallery</h3>
            </div>

            <h2 className='text-center mt-4'>Majestic HOTEL Photos</h2><br />

            <div className='gallery'>
                <img src={gal1} alt="Gallery image 1" />
                <img src={gal2} alt="Gallery image 2" />
                <img src={gal3} alt="Gallery image 3" />
            </div>

            <div className='gallery'>
                <img src={gal4} alt="Gallery image 4" />
                <img src={gal5} alt="Gallery image 5" />
                <img src={gal6} alt="Gallery image 6" />
            </div>

            <div className='gallery'>
                <img src={m1} alt="Gallery image 4" />
                <img src={m2} alt="Gallery image 5" />
                <img src={m3} alt="Gallery image 6" />
            </div>


            <h2 className='text-center mt-4'>Megha HOTEL Photos</h2><br />

            <div className='gallery'>
                <img src={gal7} alt="Gallery image 7" />
                <img src={gal8} alt="Gallery image 8" />
                <img src={gal9} alt="Gallery image 9" />
            </div>


            <div className='gallery'>
                <img src={gal9} alt="Gallery image 7" />
                <img src={gal10} alt="Gallery image 8" />
                <img src={gal11} alt="Gallery image 9" />
            </div>


            <div className='gallery'>
                <img src={gal12} alt="Gallery image 7" />
                <img src={gal13} alt="Gallery image 8" />
                <img src={gal14} alt="Gallery image 9" />
            </div>



            <br />
            <Footer />
        </>
    );
};

export default Gallery;